<template>
  <div>
    <div v-if="loading" class="text-center py-4">
      <img src="/img/loading.gif" style="height: 80px; width: 80px" />
    </div>
    <p v-else-if="topics.length === 0" class="text-muted">
      {{ $t("TRAININGS.NO_HELP") }}
    </p>
    <div v-else class="row">
      <div
        v-for="topic in topics"
        :key="topic.context"
        class="col-lg-6 col-xl-4 mb-4"
      >
        <div class="border rounded h-100">
          <div class="px-3 pt-3 pb-2">
            <h4 class="mb-0">{{ $t(contextKey(topic.context)) }}</h4>
            <small class="text-muted">
              {{ $t(contextKey(topic.context, "_WHERE")) }}
            </small>
          </div>
          <training-files-list
            :files="topic.files"
            @select="openTopic(topic, $event)"
          />
        </div>
      </div>
    </div>

    <training-files-modal
      :show="!!openedTopic"
      :title="openedTopic ? $t(contextKey(openedTopic.context)) : ''"
      :files="openedTopic ? openedTopic.files : []"
      :initial-file-id="openedFileId"
      @close="openedTopic = null"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TrainingFilesList from "@/components/Trainings/TrainingFilesList.vue";
import TrainingFilesModal from "@/components/Trainings/TrainingFilesModal.vue";
import { helpContextI18nKey } from "@/constants/helpContexts";

export default {
  name: "training-all-topics",

  components: { TrainingFilesList, TrainingFilesModal },

  data() {
    return {
      loading: true,
      openedTopic: null,
      openedFileId: null,
    };
  },

  computed: {
    ...mapGetters({ help: "trainings/help" }),
    topics() {
      return this.help.filter((topic) => topic.files.length > 0);
    },
  },

  async created() {
    try {
      await this.$store.dispatch("trainings/help");
    } catch (error) {
      this.$notify({
        type: "danger",
        message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
      });
    }
    this.loading = false;
  },

  methods: {
    contextKey: helpContextI18nKey,
    openTopic(topic, file) {
      this.openedFileId = file.id;
      this.openedTopic = topic;
    },
  },
};
</script>
